import { readable } from 'svelte/store';

export const lha = readable(null, 
    function start(set) {
      var data = [
        {
          "Stoff_nr": "190101",
          "BasPlus": "1028.51620109563"
        },
        {
          "Stoff_nr": "120100",
          "BasPlus": "1048.16500188943"
        },
        {
          "Stoff_nr": "150140",
          "BasPlus": "270.988158391532"
        },
        {
          "Stoff_nr": "290001",
          "BasPlus": "564.140286211257"
        },
        {
          "Stoff_nr": "300198",
          "BasPlus": "2705.87491248524"
        },
        {
          "Stoff_nr": "000000",
          "BasPlus": "169.117924917519"
        },
        {
          "Stoff_nr": "120300",
          "BasPlus": "112.039254208316"
        }
       ]

    set(data);
    return function stop() {
      
    };
});

export const gemeinden = readable(null, 
  function start(set) {
    var data = [
      {
        "ID_gem": "1",
        "Gemeinde": "Beaufort"
      },
      {
        "ID_gem": "2",
        "Gemeinde": "Bech"
      },
      {
        "ID_gem": "3",
        "Gemeinde": "Beckerich"
      },
      {
        "ID_gem": "4",
        "Gemeinde": "Berdorf"
      },
      {
        "ID_gem": "5",
        "Gemeinde": "Bertrange"
      },
      {
        "ID_gem": "6",
        "Gemeinde": "Bettembourg"
      },
      {
        "ID_gem": "7",
        "Gemeinde": "Bettendorf"
      },
      {
        "ID_gem": "8",
        "Gemeinde": "Betzdorf"
      },
      {
        "ID_gem": "9",
        "Gemeinde": "Bissen"
      },
      {
        "ID_gem": "10",
        "Gemeinde": "Biwer"
      },
      {
        "ID_gem": "11",
        "Gemeinde": "Boevange-sur-Attert"
      },
      {
        "ID_gem": "12",
        "Gemeinde": "Boulaide"
      },
      {
        "ID_gem": "13",
        "Gemeinde": "Bourscheid"
      },
      {
        "ID_gem": "14",
        "Gemeinde": "Bous"
      },
      {
        "ID_gem": "15",
        "Gemeinde": "Cliärref"
      },
      {
        "ID_gem": "16",
        "Gemeinde": "Colmar-Berg"
      },
      {
        "ID_gem": "17",
        "Gemeinde": "Consdorf"
      },
      {
        "ID_gem": "18",
        "Gemeinde": "Contern"
      },
      {
        "ID_gem": "19",
        "Gemeinde": "Dalheim"
      },
      {
        "ID_gem": "20",
        "Gemeinde": "Diekirch"
      },
      {
        "ID_gem": "21",
        "Gemeinde": "Differdange"
      },
      {
        "ID_gem": "22",
        "Gemeinde": "Dippach"
      },
      {
        "ID_gem": "23",
        "Gemeinde": "Dudelange"
      },
      {
        "ID_gem": "24",
        "Gemeinde": "Echternach"
      },
      {
        "ID_gem": "25",
        "Gemeinde": "Ell"
      },
      {
        "ID_gem": "26",
        "Gemeinde": "Erpeldange"
      },
      {
        "ID_gem": "27",
        "Gemeinde": "Esch-sur-Alzette"
      },
      {
        "ID_gem": "28",
        "Gemeinde": "Esch-sur-Sûre"
      },
      {
        "ID_gem": "29",
        "Gemeinde": "Ettelbruck"
      },
      {
        "ID_gem": "30",
        "Gemeinde": "Feulen"
      },
      {
        "ID_gem": "31",
        "Gemeinde": "Fischbach"
      },
      {
        "ID_gem": "32",
        "Gemeinde": "Flaxweiler"
      },
      {
        "ID_gem": "33",
        "Gemeinde": "Frisange"
      },
      {
        "ID_gem": "34",
        "Gemeinde": "Garnich"
      },
      {
        "ID_gem": "35",
        "Gemeinde": "Goesdorf"
      },
      {
        "ID_gem": "36",
        "Gemeinde": "Grevenmacher"
      },
      {
        "ID_gem": "37",
        "Gemeinde": "Grosbous"
      },
      {
        "ID_gem": "38",
        "Gemeinde": "Heffingen"
      },
      {
        "ID_gem": "39",
        "Gemeinde": "Helperknapp"
      },
      {
        "ID_gem": "40",
        "Gemeinde": "Hesperange"
      },
      {
        "ID_gem": "41",
        "Gemeinde": "Hobscheid"
      },
      {
        "ID_gem": "42",
        "Gemeinde": "Junglinster"
      },
      {
        "ID_gem": "47",
        "Gemeinde": "Käerjeng"
      },
      {
        "ID_gem": "43",
        "Gemeinde": "Kayl"
      },
      {
        "ID_gem": "44",
        "Gemeinde": "Kehlen"
      },
      {
        "ID_gem": "45",
        "Gemeinde": "Kiischpelt"
      },
      {
        "ID_gem": "105",
        "Gemeinde": "Koerich"
      },
      {
        "ID_gem": "46",
        "Gemeinde": "Kopstal"
      },
      {
        "ID_gem": "48",
        "Gemeinde": "Lac Haute-Sûre"
      },
      {
        "ID_gem": "49",
        "Gemeinde": "Larochette"
      },
      {
        "ID_gem": "50",
        "Gemeinde": "Lenningen"
      },
      {
        "ID_gem": "51",
        "Gemeinde": "Leudelange"
      },
      {
        "ID_gem": "52",
        "Gemeinde": "Lintgen"
      },
      {
        "ID_gem": "53",
        "Gemeinde": "Lorentzweiler"
      },
      {
        "ID_gem": "54",
        "Gemeinde": "Luxembourg"
      },
      {
        "ID_gem": "55",
        "Gemeinde": "Mamer"
      },
      {
        "ID_gem": "56",
        "Gemeinde": "Manternach"
      },
      {
        "ID_gem": "57",
        "Gemeinde": "Mersch"
      },
      {
        "ID_gem": "58",
        "Gemeinde": "Mertert"
      },
      {
        "ID_gem": "59",
        "Gemeinde": "Mertzig"
      },
      {
        "ID_gem": "60",
        "Gemeinde": "Mompach"
      },
      {
        "ID_gem": "61",
        "Gemeinde": "Mondercange"
      },
      {
        "ID_gem": "62",
        "Gemeinde": "Mondorf-les-Bains"
      },
      {
        "ID_gem": "63",
        "Gemeinde": "Niederanven"
      },
      {
        "ID_gem": "64",
        "Gemeinde": "Nommern"
      },
      {
        "ID_gem": "65",
        "Gemeinde": "Parc Hosingen"
      },
      {
        "ID_gem": "68",
        "Gemeinde": "Pétange"
      },
      {
        "ID_gem": "66",
        "Gemeinde": "Preizerdaul"
      },
      {
        "ID_gem": "67",
        "Gemeinde": "Putscheid"
      },
      {
        "ID_gem": "69",
        "Gemeinde": "Rambrouch"
      },
      {
        "ID_gem": "70",
        "Gemeinde": "Reckange-sur-Mess"
      },
      {
        "ID_gem": "71",
        "Gemeinde": "Redange"
      },
      {
        "ID_gem": "72",
        "Gemeinde": "Reisdorf"
      },
      {
        "ID_gem": "73",
        "Gemeinde": "Remich"
      },
      {
        "ID_gem": "74",
        "Gemeinde": "Roeser"
      },
      {
        "ID_gem": "75",
        "Gemeinde": "Rosport"
      },
      {
        "ID_gem": "76",
        "Gemeinde": "Rumelange"
      },
      {
        "ID_gem": "77",
        "Gemeinde": "Saeul"
      },
      {
        "ID_gem": "78",
        "Gemeinde": "Sandweiler"
      },
      {
        "ID_gem": "79",
        "Gemeinde": "Sanem"
      },
      {
        "ID_gem": "80",
        "Gemeinde": "Schengen"
      },
      {
        "ID_gem": "81",
        "Gemeinde": "Schieren"
      },
      {
        "ID_gem": "82",
        "Gemeinde": "Schifflange"
      },
      {
        "ID_gem": "83",
        "Gemeinde": "Schuttrange"
      },
      {
        "ID_gem": "84",
        "Gemeinde": "Septfontaines"
      },
      {
        "ID_gem": "85",
        "Gemeinde": "Stadtbredimus"
      },
      {
        "ID_gem": "86",
        "Gemeinde": "Steinfort"
      },
      {
        "ID_gem": "87",
        "Gemeinde": "Steinsel"
      },
      {
        "ID_gem": "88",
        "Gemeinde": "Strassen"
      },
      {
        "ID_gem": "89",
        "Gemeinde": "Tandel"
      },
      {
        "ID_gem": "90",
        "Gemeinde": "Troisvierges"
      },
      {
        "ID_gem": "91",
        "Gemeinde": "Useldange"
      },
      {
        "ID_gem": "92",
        "Gemeinde": "Vallée de l`Ernz"
      },
      {
        "ID_gem": "93",
        "Gemeinde": "Vianden"
      },
      {
        "ID_gem": "94",
        "Gemeinde": "Vichten"
      },
      {
        "ID_gem": "95",
        "Gemeinde": "Wahl"
      },
      {
        "ID_gem": "96",
        "Gemeinde": "Waldbillig"
      },
      {
        "ID_gem": "97",
        "Gemeinde": "Waldbredimus"
      },
      {
        "ID_gem": "98",
        "Gemeinde": "Walferdange"
      },
      {
        "ID_gem": "99",
        "Gemeinde": "Weiler-la-Tour"
      },
      {
        "ID_gem": "100",
        "Gemeinde": "Weiswampach"
      },
      {
        "ID_gem": "101",
        "Gemeinde": "Wiltz"
      },
      {
        "ID_gem": "102",
        "Gemeinde": "Wincrange"
      },
      {
        "ID_gem": "103",
        "Gemeinde": "Winseler"
      },
      {
        "ID_gem": "104",
        "Gemeinde": "Wormeldange"
      }
     ]
    set(data);
  return function stop() {
    
  };
});

export const abfuhren = readable(null, 
  function start(set) {
    var data = [
      {
        "Vk_ID_gem": "1",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "1",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "1",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "1",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "1",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "1",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "2",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "2",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "2",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "2",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "2",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "2",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "3",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "3",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "3",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "3",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "3",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "3",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "4",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "4",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "4",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "4",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "4",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "4",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "5",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "5",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "13"
      },
      {
        "Vk_ID_gem": "5",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "13"
      },
      {
        "Vk_ID_gem": "5",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "5",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "43"
      },
      {
        "Vk_ID_gem": "5",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "6",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "6",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "6",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "6",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "6",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "6",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "7",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "7",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "7",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "7",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "7",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "7",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "8",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "8",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "8",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "8",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "8",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "8",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "9",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "9",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "9",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "9",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "9",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "9",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "10",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "10",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "10",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "10",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "10",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "10",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "11",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "11",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "11",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "11",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "11",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "11",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "12",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "12",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "12",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "12",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "12",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "12",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "13",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "13",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "13",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "13",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "13",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "13",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "14",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "14",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "14",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "14",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "14",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "14",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "15",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "15",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "15",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "15",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "15",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "15",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "16",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "16",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "16",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "16",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "16",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "16",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "17",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "17",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "17",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "17",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "17",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "17",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "18",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "18",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "18",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "18",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "18",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "46"
      },
      {
        "Vk_ID_gem": "18",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "19",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "19",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "19",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "19",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "19",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "19",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "20",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "20",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "20",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "20",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "20",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "20",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "21",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "21",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "21",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "21",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "21",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "42"
      },
      {
        "Vk_ID_gem": "21",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "22",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "22",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "22",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "22",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "22",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "44"
      },
      {
        "Vk_ID_gem": "22",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "23",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "23",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "13"
      },
      {
        "Vk_ID_gem": "23",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "13"
      },
      {
        "Vk_ID_gem": "23",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "23",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "44"
      },
      {
        "Vk_ID_gem": "23",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "24",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "24",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "24",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "24",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "24",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "24",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "25",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "25",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "25",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "25",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "25",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "25",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "26",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "26",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "26",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "26",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "26",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "26",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "27",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "27",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "27",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "27",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "27",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "27",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "28",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "28",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "28",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "28",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "28",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "28",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "29",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "29",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "29",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "29",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "29",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "29",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "30",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "30",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "30",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "30",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "30",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "30",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "31",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "31",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "31",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "31",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "31",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "31",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "32",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "32",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "32",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "32",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "32",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "32",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "33",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "33",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "33",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "33",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "33",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "44"
      },
      {
        "Vk_ID_gem": "33",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "34",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "34",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "34",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "34",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "34",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "43"
      },
      {
        "Vk_ID_gem": "34",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "35",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "35",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "35",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "35",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "35",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "35",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "36",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "36",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "36",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "36",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "36",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "36",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "37",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "37",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "37",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "37",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "37",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "37",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "38",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "38",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "38",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "38",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "38",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "38",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "39",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "39",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "39",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "39",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "39",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "39",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "40",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "40",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "40",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "40",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "40",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "40",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "41",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "41",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "41",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "41",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "41",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "44"
      },
      {
        "Vk_ID_gem": "41",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "42",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "42",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "42",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "42",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "42",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "40"
      },
      {
        "Vk_ID_gem": "42",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "43",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "43",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "43",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "43",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "43",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "43",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "44",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "44",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "13"
      },
      {
        "Vk_ID_gem": "44",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "13"
      },
      {
        "Vk_ID_gem": "44",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "44",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "44"
      },
      {
        "Vk_ID_gem": "44",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "45",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "45",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "45",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "45",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "45",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "45",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "46",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "46",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "13"
      },
      {
        "Vk_ID_gem": "46",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "13"
      },
      {
        "Vk_ID_gem": "46",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "46",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "43"
      },
      {
        "Vk_ID_gem": "46",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "47",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "47",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "47",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "47",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "47",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "43"
      },
      {
        "Vk_ID_gem": "47",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "48",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "48",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "48",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "48",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "48",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "48",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "49",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "49",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "49",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "49",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "49",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "49",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "50",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "50",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "50",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "50",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "50",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "50",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "51",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "51",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "51",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "51",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "51",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "45"
      },
      {
        "Vk_ID_gem": "51",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "52",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "52",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "52",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "52",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "52",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "52",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "53",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "53",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "53",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "53",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "53",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "53",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "54",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "54",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "54",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "54",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "54",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "54",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "55",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "55",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "13"
      },
      {
        "Vk_ID_gem": "55",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "13"
      },
      {
        "Vk_ID_gem": "55",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "55",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "44"
      },
      {
        "Vk_ID_gem": "55",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "56",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "56",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "56",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "56",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "56",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "56",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "57",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "57",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "57",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "57",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "57",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "57",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "58",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "58",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "58",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "58",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "58",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "58",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "59",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "59",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "59",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "59",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "59",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "59",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "60",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "60",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "60",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "60",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "60",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "60",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "61",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "61",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "61",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "61",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "61",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "45"
      },
      {
        "Vk_ID_gem": "61",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "62",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "62",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "62",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "62",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "62",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "62",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "63",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "63",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "24"
      },
      {
        "Vk_ID_gem": "63",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "63",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "63",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "63",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "64",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "64",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "64",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "64",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "64",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "64",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "65",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "65",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "65",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "65",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "65",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "65",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "66",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "66",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "66",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "66",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "66",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "66",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "67",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "67",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "67",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "67",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "67",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "67",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "68",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "68",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "68",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "68",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "68",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "68",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "69",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "69",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "69",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "69",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "69",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "69",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "70",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "70",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "13"
      },
      {
        "Vk_ID_gem": "70",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "13"
      },
      {
        "Vk_ID_gem": "70",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "70",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "70",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "71",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "71",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "71",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "71",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "71",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "71",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "72",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "72",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "72",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "72",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "72",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "72",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "73",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "73",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "73",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "73",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "73",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "73",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "74",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "74",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "74",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "74",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "74",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "46"
      },
      {
        "Vk_ID_gem": "74",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "75",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "75",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "75",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "75",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "75",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "75",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "76",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "76",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "76",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "76",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "76",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "40"
      },
      {
        "Vk_ID_gem": "76",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "77",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "77",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "77",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "77",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "77",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "77",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "78",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "78",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "78",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "78",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "78",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "46"
      },
      {
        "Vk_ID_gem": "78",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "79",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "79",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "79",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "79",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "79",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "43"
      },
      {
        "Vk_ID_gem": "79",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "80",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "80",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "80",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "80",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "80",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "80",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "81",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "81",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "81",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "81",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "81",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "81",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "82",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "82",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "82",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "82",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "82",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "82",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "82",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "45"
      },
      {
        "Vk_ID_gem": "82",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "83",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "83",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "83",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "83",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "83",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "46"
      },
      {
        "Vk_ID_gem": "83",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "84",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "84",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "13"
      },
      {
        "Vk_ID_gem": "84",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "13"
      },
      {
        "Vk_ID_gem": "84",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "84",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "44"
      },
      {
        "Vk_ID_gem": "84",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "85",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "85",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "85",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "85",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "85",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "85",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "86",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "86",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "13"
      },
      {
        "Vk_ID_gem": "86",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "13"
      },
      {
        "Vk_ID_gem": "86",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "86",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "44"
      },
      {
        "Vk_ID_gem": "86",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "87",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "87",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "24"
      },
      {
        "Vk_ID_gem": "87",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "87",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "87",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "34"
      },
      {
        "Vk_ID_gem": "87",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "88",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "88",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "88",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "88",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "88",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "88",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "89",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "89",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "89",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "89",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "89",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "89",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "90",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "90",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "90",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "90",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "90",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "90",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "91",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "91",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "91",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "91",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "91",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "91",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "92",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "92",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "92",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "92",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "92",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "92",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "93",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "93",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "93",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "93",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "93",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "93",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "94",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "94",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "94",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "94",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "94",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "94",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "95",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "95",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "95",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "95",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "95",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "95",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "96",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "96",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "96",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "96",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "96",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "96",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "97",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "97",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "97",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "97",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "97",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "97",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "98",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "98",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "98",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "15"
      },
      {
        "Vk_ID_gem": "98",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "98",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "44"
      },
      {
        "Vk_ID_gem": "98",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "99",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "99",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "24"
      },
      {
        "Vk_ID_gem": "99",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "99",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "99",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "43"
      },
      {
        "Vk_ID_gem": "99",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "100",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "100",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "100",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "100",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "100",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "100",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "101",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "101",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "101",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "101",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "101",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "101",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "102",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "102",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "102",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "102",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "102",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "102",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "103",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "103",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "12"
      },
      {
        "Vk_ID_gem": "103",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "9"
      },
      {
        "Vk_ID_gem": "103",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "103",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "39"
      },
      {
        "Vk_ID_gem": "103",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "104",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "104",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "104",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "104",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "104",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "52"
      },
      {
        "Vk_ID_gem": "104",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "105",
        "Vk_Stoff_nr": "000000",
        "Frequenz": "4"
      },
      {
        "Vk_ID_gem": "105",
        "Vk_Stoff_nr": "120100",
        "Frequenz": "13"
      },
      {
        "Vk_ID_gem": "105",
        "Vk_Stoff_nr": "150140",
        "Frequenz": "13"
      },
      {
        "Vk_ID_gem": "105",
        "Vk_Stoff_nr": "190101",
        "Frequenz": "26"
      },
      {
        "Vk_ID_gem": "105",
        "Vk_Stoff_nr": "290001",
        "Frequenz": "44"
      },
      {
        "Vk_ID_gem": "105",
        "Vk_Stoff_nr": "300198",
        "Frequenz": "26"
      }
    ]
    set(data);
  return function stop() {
    
  };
});



